import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Container } from '@mui/material';

import { url ,fileUploadUrl} from "../../../../constant";

const failureCtaData = {
  "id": 1,
  "title": "Ready to Take the Next Step?",
  "description": "Whether you're just getting started or scaling up, our platform is built to help you succeed. We offer powerful tools, flexible integrations, and expert support designed to match your unique goals. From launching your first project to managing enterprise-level operations, we stand by your side every step of the way. Explore resources, insights, and features tailored to drive your growth and make your journey smoother.",
  "button_text": "Get Started Now",
  "created_at": "2025-08-25T13:52:01.000000Z",
  "updated_at": "2025-09-01T11:19:44.000000Z"
};

const CTASection = () => {
  
  const [loading, setLoading] = useState(false);
  const [ctaData, setCtaData] = useState([
    {
      "id": 1,
      "title": "Ready to Take the Next Step?",
      "description": "Whether you're just getting started or scaling up, our platform is built to help you succeed. We offer powerful tools, flexible integrations, and expert support designed to match your unique goals. From launching your first project to managing enterprise-level operations, we stand by your side every step of the way. Explore resources, insights, and features tailored to drive your growth and make your journey smoother.",
      "button_text": "Get Started Now",
      "button_link": "https://www.google.com",
      "created_at": "2025-08-25T13:52:01.000000Z",
      "updated_at": "2025-09-01T11:19:44.000000Z"
    }
  ]);

  useEffect(() => {
    fetchCtaSections();
  }, []);

  const fetchCtaSections = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${url}auth/get-cta-sections`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);

      const data = await res.json();

      if (data.length > 0) {
        setCtaData(data[0]); // Assuming only 1 CTA section is returned
        console.log("get-cta-sections", data);
      }

    } catch (err) {
      console.log("err", err);
      // keep default CTAData
      setCtaData([
        {
          "id": 1,
          "title": "Ready to Take the Next Step?",
          "description": "Whether you're just getting started or scaling up, our platform is built to help you succeed. We offer powerful tools, flexible integrations, and expert support designed to match your unique goals. From launching your first project to managing enterprise-level operations, we stand by your side every step of the way. Explore resources, insights, and features tailored to drive your growth and make your journey smoother.",
          "button_text": "Get Started Now",
          "created_at": "2025-08-25T13:52:01.000000Z",
          "updated_at": "2025-09-01T11:19:44.000000Z"
        }
      ]);

    } finally {
      setLoading(false);
    }
  };


  return (
    <Box sx={{ py: { xs: 6, sm: 12, md: 4 }, backgroundColor: '#f9f9f9' }}>
      <Container maxWidth="md">
        <Box
          textAlign="center"
          sx={{
            maxWidth: 900,
            mx: 'auto',
            px: { xs: 2, sm: 3, md: 0 },
          }}
        >
          {/* Main Heading */}
          <Typography variant="h3" fontWeight="bold" mb={7} gutterBottom>
            {/* Ready to Take the Next Step? */}
              {ctaData.title || failureCtaData.title}
          </Typography>

          {/* Content - Slightly Smaller & Softer */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              fontSize: '0.855rem', // ~17.6px for slightly better readability
              fontWeight: 400,
              lineHeight: 2,
            }}
          >
            {/* Whether you're just getting started or scaling up, our platform is built to help you succeed.
            We offer powerful tools, flexible integrations, and expert support designed to match your unique goals.
            From launching your first project to managing enterprise-level operations, we stand by your side every step of the way.
            Explore resources, insights, and features tailored to drive your growth and make your journey smoother. */}

            {ctaData.description || failureCtaData.description}
          </Typography>

          {/* CTA Button */}
          <Button
            variant="contained"
            size="medium"
            href={ctaData.button_link || failureCtaData.button_link} // ✅ Add link here
            target="_blank" // ✅ Opens in new tab
            rel="noopener noreferrer" // ✅ Security best practice
            sx={{
              px: 2,
              py: 1,
              fontSize: '0.9rem', // ~16px
              backgroundColor: '#1976d2',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            {/* Get Started Now */}

            {ctaData.button_text || failureCtaData.button_text}
          </Button>
        </Box>
      </Container>
    </Box>
  );

};

export default CTASection;
